import { type DevString, type Handler, dev } from "@phosphor/utils";
import { type Atom, type PrimitiveAtom, atom } from "jotai";
import { type UID, World } from "#scripts/vmc/WorldState.ts";

/** "from direction" for keyboard navigation */
export type ExitDirection = "enter" | "escape" | "up" | "down" | "left" | "right";

// #region cfocusable-component
export class CFocusable extends World.Component("focusable")<
  CFocusable,
  {
    handler: Handler<ExitDirection>;
    hasDirectFocusAtom: Atom<boolean>;
  }
>() {
  // #hide implementation
  static Plugin = World.definePlugin({
    name: dev`Focusable`.ctx({ loc: "phosphor-blog/scripts/keyboard-demo/plugins/CFocusable.ts:18:11" }),
    setup(build) {
      const { store } = build;
      const activeFocusAtom = atom<UID | null>(null);
      build.addUnique(UCurrentFocus, { activeFocusAtom });
      build.onEntityCreated(
        { requires: [CFocusable] },
        (uid, { focusable: { hasDirectFocusAtom } }, _world, onDeath) => {
          const world = store.get(build.worldAtom);
          if (!world) return;
          onDeath.add(() => {
            store.set(activeFocusAtom, (curr) => (curr === uid ? null : curr));
          });
          onDeath.add(
            store.sub(hasDirectFocusAtom, () => {
              if (store.get(hasDirectFocusAtom)) {
                store.set(activeFocusAtom, uid);
              } else {
                store.set(activeFocusAtom, (curr) => (curr === uid ? null : curr));
              }
            }),
          );
        },
      );
    },
  });
  // #endhide implementation
}
// #endregion cfocusable-component

// #region ucurrent-focus-unique
export class UCurrentFocus extends World.Unique("currentFocus")<
  UCurrentFocus,
  { activeFocusAtom: PrimitiveAtom<UID | null> }
>() {}
// #endregion ucurrent-focus-unique

export class CSelectable extends World.Component("selectable")<CSelectable, {}>() {}

export class CSelected extends World.Component("selected")<
  CSelected,
  {
    isSelectedAtom: Atom<boolean>;
    clickHandler: (reason: DevString, event: any) => any;
  }
>() {}

export class UCurrentSelection extends World.Unique("currentSelection")<
  UCurrentSelection,
  {
    selectedUIDsAtom: Atom<UID[]>;
  }
>() {}
